import { useState, useEffect } from 'react';
import { Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { updateUserRoles } from '../../../services/adminService';

const UpdateUserRoles = ({ userEmail }) => {
    const [formData, setFormData] = useState({
        userEmail: '',
        userClaimsRoles: []
    });

    const userClaimsRolesList = [
        { label: "Admin", value: "Admin" },
        { label: "Service Lead", value: "Service Lead" },
        { label: "Chat", value: "Chat" },
        { label: "NRT Approval", value: "NRT Approval" },
        { label: "NRT Deliveries", value: "NRT Deliveries" },
        { label: "Reporting", value: "Reporting" }
    ];

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            userEmail: userEmail // Set userEmail when prop changes
        }));
    }, [userEmail]); // This effect will run when userEmail changes


    const handleRoleChange = (e) => {
        const { value, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            userClaimsRoles: checked
                ? [...prevData.userClaimsRoles, value]
                : prevData.userClaimsRoles.filter(role => role !== value)
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage('');
        setErrorMessage('');

        try {
            const result = await updateUserRoles(formData);

            if (result) {
                setSuccessMessage('User roles updated successfully!');
                setFormData({
                    userClaimsRoles: []
                });
            }
        } catch (error) {
            setErrorMessage('Failed to update user roles.');
            console.error(error);
        }
    };

    return (
        <div className="pt-3">
            <Row>
                <Col xs={12}>
                    <hr />
                    <h3 className="pt-3">Update User Roles</h3>

                    <Form onSubmit={handleSubmit}>

                        <Form.Control className="my-3" name="userEmail" value={userEmail} readonly required />

                        {userClaimsRolesList.map((role) => (
                            <Form.Check
                                className="mb-3"
                                key={role.value}
                                type="checkbox"
                                label={role.label}
                                value={role.value}
                                onChange={handleRoleChange}
                                checked={formData.userClaimsRoles.includes(role.value)}
                            />
                        ))}

                        <Button variant="primary" type="submit" className="mb-3">
                            Update Roles
                        </Button>
                    </Form>

                    {successMessage && <Alert variant="success">{successMessage}</Alert>}
                    {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

                </Col>
            </Row>
        </div>
    );
};

export default UpdateUserRoles;
